<template>
  <div class="mainBox">
    <!-- <div class="title">
      <van-icon name="balance-list-o" color="#1989fa" size="23"/>
      <span>云赢工资条</span>
    </div> -->
    <template v-if="isVerify">
      <div class="selectBox" v-if="!isGetOtherCallback">
        <van-button class="select_button" @click="showPicker()" size="small" style="">{{selectSalaryName}}
          <van-icon name="arrow-down" color="#000" size="20"/>
        </van-button>
      </div>
      <div class="selectBox" v-if="isGetOtherCallback">
        <van-button class="select_button" size="small" style="color:#333" v-if="callbackUserInfo.month">{{callbackUserInfo.nickName+callbackUserInfo.month}}月薪资</van-button>
      </div>
      <div class="panleBox" v-show="dataVisible">
        <div class="section van-hairline--top">
          <div style="background-color: #fff;" class="brs brs_box">
            <div style="padding: 0px 6px 10px 6px;">
              <div>
                <p class="key" style="width: 100%;text-align: center;color: #fff;font-size: 14px;">{{fkForm.month}}月实发工资(元)</p>
                <div class="value" style="font-size: 40px;width: 100%;text-align: center;color:#fff">{{moneyTotal}}</div>
              </div>
              <!-- <div class="lineNum"><span>福建云赢文化传媒有限公司</span></div> -->
              <div class="lineNum2"><span>福建云赢文化传媒有限公司</span></div>
            </div>
          </div>
          <div class="details brs_bottom">
            <div class="lineNum"><span class="lineNum_flag"></span><span>工资明细</span></div>
            <div style="padding:0px 6px 10px 6px;">
              <div class="flex-mb8 atu" v-for="(title,index) in salaryDetailHeader" :key='index'>
                <span class="key">{{title}}</span>
                <span class="value">{{ salaryDetailItems[index] }}</span>
              </div>
            </div>
          </div>
          <div style="background-color: #fff;box-shadow: 0 0.26667rem 0.4rem -0.4rem #000;" v-if="isGetOtherCallback">
            <div class="lineNum"><span style="color: red;margin-left: 0.3rem;"><van-icon name="question" />&nbsp;反馈详情</span></div>
            <div style="padding:0px 6px 10px 6px;">
              <van-field v-model="callbackUserInfo.remark" type="textarea" label="反馈内容" label-width="60px"  readonly />
              <van-field v-model="callbackUserInfo.createTime" label="反馈时间" label-width="60px"  readonly />
            </div>
          </div>
        </div>
      </div>
      <div class="panleBox" v-show="!dataVisible">
        <div class="section van-hairline--top" style="text-align: center;">
          <span>正在加载中...</span>
        </div>
      </div>
      <!-- <div>
        <p style="font-size: 14px;line-height: 60px;text-align: center;">找不到相关数据</p>
      </div> -->
      <p v-if="salaryDetail.length>0&&!over && !isGetOtherCallback" class="banner">
        <van-button size="normal" type="info" @click="confirmHandle(1)" style="margin-right:0.4rem">
          &nbsp;&nbsp;确&nbsp;&nbsp;&nbsp;&nbsp;认&nbsp;&nbsp;
        </van-button>
        <van-button size="normal" type="info" plain hairline @click="confirmHandle(2)">{{callback?'再次反馈':'问题反馈'}}</van-button>
        <!-- <span class="question_icon">?</span> -->
      </p>
      <!-- <p v-if="!over" class="banner">
        <span>提示：两小时后系统将自动确认，有问题请及时反馈</span>
      </p> -->
      <p v-if="over && !isGetOtherCallback" class="banner">
        <van-icon name="checked" class="checkedIcon"/><span class="checkedIcon">已确认</span>
      </p>
      <p v-if="salaryDetail.length==0 && !isGetOtherCallback" style="margin-top:2rem;text-align: center;">
        <van-icon name="warning" color="#2d7ee3" size="18" style=";font-size: 16px;margin: 0 5px 0 0;"/><span style="font-size:14px">本月暂无工资明细</span>
      </p>
    </template>

    <van-dialog v-model="passwordVisible" title="验证密码" style="width:90%;" :beforeClose="verifyPassword">
      <div class="password_content" style="margin-top:20px;padding: 5px;">
        <van-cell-group>
          <van-field class="t_vant_field" v-model="password" clearable :type="passwordType" label="密码" required>
            <template slot="right-icon">
              <span class="solts" @click="switchPasswordType">
                <van-icon name="closed-eye" v-if="passwordType==='password'" />
                <van-icon name="eye" v-else />
              </span>
            </template>
          </van-field>
          <van-cell style="color: #ff976a;" :title="'注：默认密码为手机号码后六位，或123456。'" />
        </van-cell-group>
      </div>
    </van-dialog>

    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>
    <van-dialog v-model="showFkPop" title="反馈工资问题"
      style="width:90%;min-height:50%" :beforeClose="beforeClose" close-on-click-overlay>
      <div style="margin-top:20px">
        <van-form ref="fkForm" validate-trigger="onSubmit" >
          <van-cell-group style="width:99%;">
            <van-field v-model="fkForm.remark" rows="10" maxlength="300" type="textarea" label="反馈内容" label-width="65px" :rules="[{ required: true }]" placeholder="请填写反馈内容" required />
          </van-cell-group>
        </van-form>
      </div>
    </van-dialog>
  </div>
</template>

<script>

import { List, Cell, Button, Tag, Dialog, Area, Toast, Icon, Field, Col, Row, CellGroup, Popup, Picker, Radio, RadioGroup, Grid, GridItem, Tab, Tabs, Form, Calendar } from 'vant'
import { getSalaryDetailed, callback, mySalaryList, mySalarySelection, sendMessageCommon, callbackInfo, checkPassword } from '@/api/admi/salary'
import { listUser } from '@/api/admi/user'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { getQywxAppId } from '@/api/auth/auth'
import { verifyContract } from '@/api/cont/nocontract'

export default {
  computed: {
    ...mapGetters({
      userinfo: 'userinfo'
    })
  },
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Form.name]: Form,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Form.name]: Form,
    [Calendar.name]: Calendar
  },
  data() {
    return {
      isVerify: false,
      password: null,
      passwordVisible: true,
      passwordType: 'password',
      picker: {
        visible: false,
        title: '',
        columns: []
      },
      salaryDetail: {
        claimStatus: '0'
      },
      showClonms: [],
      salaryDetailHeader: [],
      salaryDetailItems: [],
      moneyTotal: '',
      fkForm: {
        month: this.$route.query.month,
        nickName: this.$store.state.user.user.nickName,
        cbType: 1, // 1 确认 2 反馈 3 反馈回复 4 查看
        remark: ''
      },
      nickName: this.$store.state.user.user.nickName,
      showFkPop: false,
      dataVisible: false,
      over: false,
      callback: false,
      isGetOtherCallback: false, // 查看反馈者的工资信息
      selectSalaryName: this.$route.query.month + '月薪资',
      monthOptions: [],
      balanceStatusOptions: {},
      claimStatusOptions: {},
      // 产品类型树选项
      businessTypeTreeOptions: this.$store.state.dictOptions.businessTypeTree || [],
      sendMessageDatas: {
        month: this.$route.query.month,
        title: this.$route.query.month + '工资问题反馈-' + this.$store.state.user.user.nickName,
        callbackId: '',
        toUser: '',
        nickName: this.$store.state.user.user.nickName,
        isCallback: '1', // 1反馈 0工资条
        remark: ''
      },
      callbackUserInfo: {
        remark: '反馈者的反馈信息',
        createTime: '2021-12-12 12:35:12'
      }
    }
  },
  mounted() {
    this.init()

    // 不是查看反馈时，调用月份方法
    if (this.$route.query.isCallback != 1) {
      this.getMonth()
    }
    // 访问标记查看
    if (this.$route.query.month) {
      this.setType(4)
    }
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    verifyPassword(type, done) {
      if (!this.password) {
        Toast.fail('请输入密码后验证!')
        return done(false)
      }
      checkPassword(this.password).then(res => {
        if (res.code === 200) {
          Toast.success('验证成功')
          this.passwordVisible = false
          this.isVerify = true
          done()
        } else {
          Toast.fail('密码有误，请重新输入并验证!')
          done(false)
        }
      })
    },
    timeFormat(val) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss')
    },
    init() {
      const _this = this
      document.title = '我的工资条'
      let month = this.$route.query.month || null
      const isCallback = this.$route.query.isCallback || ''
      const name = isCallback == 1 ? this.$route.query.nickName : this.nickName
      if (!month) {
        mySalaryList(name).then((response) => {
          if (response.code == 200) {
            const resData = response.data || []
            month = resData.length > 0 ? resData[0] : null
            if (month) {
              this.fkForm.month = month
              _this.selectSalaryName = month + '月薪资'
              if (isCallback == 1) {
                const callbackId = this.$route.query.callbackId || ''
                this.getCallbackList(callbackId)
                document.title = '薪资反馈'
              }
              this.isGetOtherCallback = isCallback == 1
              this.getMySalary(name, month)
              // 查询工资条确认/反馈情况
              const params = {
                cbType: 1,
                month: month,
                nickName: name
              }
              this.getSituation(params, 1)
              this.getSituation(params, 2)
              _this.dataVisible = true
            } else {
              _this.dataVisible = false
              _this.selectSalaryName = '暂无工资条'
            }
          }
        })
      } else {
        if (isCallback == 1) {
          const callbackId = this.$route.query.callbackId || ''
          this.getCallbackList(callbackId)
          document.title = '工资条反馈'
        }
        this.isGetOtherCallback = isCallback == 1
        this.getMySalary(name, month)
        // 查询工资条确认/反馈情况
        const params = {
          cbType: 1,
          month: month,
          nickName: name
        }
        this.getSituation(params, 1)
        this.getSituation(params, 2)
      }
    },
    setType(type) {
      this.fkForm.cbType = type
      callback(this.fkForm).then((response) => {
        if (response.code == 200) {
          console.log('标记类型：' + type)
        }
      })
    },
    getCallbackList(id) {
      (id).then(response => {
        this.callbackUserInfo = response.data
        this.callbackUserInfo.createTime = this.timeFormat(this.callbackUserInfo.createTime)
      })
    },
    getUserQYWXid(name) {
      const querys = {
        userName: name
      }
      listUser(querys).then(response => {
        const userList = response.rows[0]
        this.sendMessageDatas.toUser = userList.qywxUserid || ''
      })
    },
    async getMySalary(name, month) {
      const res = await getSalaryDetailed(name, month)
      if (res.code === 200 && res.data.length > 0) {
        this.dataVisible = true
        const data = res.data || null
        this.salaryDetail = eval(data) || []
        const toUser = this.salaryDetail[3].createBy
        this.getUserQYWXid(toUser)
        this.showClonms = this.salaryDetail[2] ? this.salaryDetail[2].split(',') : []
        const columns = []
        const columns_1 = []
        if (this.salaryDetail[0]) {
          for (let i = 0; i < this.salaryDetail[0].length; i++) {
            const item = this.salaryDetail[0][i]
            const tt = this.showClonms.find(it => it === item)
            if (tt && this.salaryDetail[1][i] !== 'null' && this.salaryDetail[1][i] !== '0') {
              columns.push(tt)
              columns_1.push(this.salaryDetail[1][i] === 'null' ? '' : this.salaryDetail[1][i])
            }
            if (item == '实发' || item == '实发工资') {
              this.moneyTotal = this.salaryDetail[1][i]
            }
          }
          this.salaryDetailHeader = columns
          this.salaryDetailItems = columns_1
          // 查询确认、反馈状态
          const params = {
            cbType: 1,
            month: month,
            nickName: name
          }
          this.getSituation(params, 1)
          this.getSituation(params, 2)
        }
      } else {
        Toast.fail('暂无数据信息')
      }
    },
    getMonth() {
      const name = this.nickName || ''
      this.monthOptions = []
      mySalaryList(name).then((response) => {
        if (response.code == 200) {
          const resData = response.data || []
          const datas = []
          for (let i = resData.length - 1; i >= 0; i--) {
            datas.push(resData[i])
          }
          datas.forEach(element => {
            const list = { month: element, name: element + '月薪资' }
            this.monthOptions.push(list)
          })
        }
      })
    },
    // 查询工资条确认/反馈情况
    getSituation(params, type) {
      params.cbType = type || 1
      mySalarySelection(params).then((response) => {
        if (response.code == 200) {
          const tag = response.rows
          if (type == 1) {
            if (tag.length > 0) {
              // 确认
              this.over = true
            } else {
              this.over = false
            }
          } else if (type == 2) {
            if (tag.length > 0) {
            // 反馈
              this.callback = true
            } else {
              this.callback = false
            }
          }
        }
      })
    },
    balanceStatusFormat(balanceStatus) {
      return this.selectDictLabel(this.balanceStatusOptions, balanceStatus)
    },
    invoiceTypeFormat(row, column) {
      return this.selectDictLabel(this.invoiceTypeOptions, row.invoiceType)
    },
    confirmHandle(cbType) {
      this.fkForm.cbType = cbType
      if (cbType == 1) {
        this.fkForm.remark = ''
        Dialog.confirm({
          message: '是否确认工资？'
        })
          .then(() => {
            callback(this.fkForm).then((response) => {
              Toast.success('已确认')
              this.over = true
              this.salaryDetail.claimStatus = '1'
              this.setType(1)
            })
          })
          .catch(() => {
          })
      } else {
        this.showFkPop = true
      }
    },
    // 添加反馈
    async beforeClose(type, done) {
      this.fkForm.cbType = 2
      if (type === 'confirm') {
        try {
          await this.$refs.fkForm.validate()
          this.sendMessageDatas.remark = this.fkForm.remark
          this.sendMessageDatas.month = this.fkForm.month
          this.sendMessageDatas.title = this.fkForm.month + '工资问题反馈-' + this.fkForm.nickName
          if (this.callback) {
            Dialog.confirm({
              message: '您已提交反馈，是否确认再次提交？'
            })
              .then(() => {
                callback(this.fkForm).then((response) => {
                  this.sendMessageDatas.callbackId = response.data || ''
                  if (response.data) {
                    this.$nextTick(() => {
                      // 反馈提醒
                      sendMessageCommon(this.sendMessageDatas).then(response => {}).catch(err => { console.log(err) })
                    })
                  }
                  Toast.success('反馈成功!')
                  this.showFkPop = false
                  this.callback = true
                })
                done()
              }).catch(() => {
                this.showFkPop = false
              })
          } else {
            callback(this.fkForm).then((response) => {
              this.sendMessageDatas.callbackId = response.data || ''
              if (response.data) {
                this.$nextTick(() => {
                  // 反馈提醒
                  sendMessageCommon(this.sendMessageDatas).then(response => {}).catch(err => { console.log(err) })
                })
              }
              Toast.success('反馈成功!')
              this.showFkPop = false
              this.callback = true
            })
            done()
          }
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    formatDate(date) { // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    showPicker() {
      this.picker.columns = this.monthOptions.map((ele) => ele.name)
      this.picker.visible = true
    },
    pickerCancel() {
      this.picker.visible = false
    },
    pickerChange() { },
    pickerConfirm(value, index) {
      const salaryMonth = this.monthOptions[index].month
      this.fkForm.month = salaryMonth
      const salaryName = this.monthOptions[index].name
      this.selectSalaryName = salaryName
      this.picker.visible = false
      const name = this.nickName || ''
      this.getMySalary(name, salaryMonth)
    }
  }
}
</script>
<style lang="less" scoped>
.t_vant_field {
  .van-field__right-icon {
    .solts {
      right: -15px;
    }
  }
}
  .title{
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    margin: 30px 0 0 30px;
    span{
      font-size: 32px;
      margin-left: 5px;
    }

    .icon {
      display: inline-block;
      width: 40px;
      height: 40px;
    }
  }
  .selectBox{
    // margin-left:20%;
    display: flex;
    align-items: center;
    .select_button{
      width: 100%;
      height: 1.39rem;
      position: fixed;
      top: 0;
      z-index: 100;
      span,i{
        font-size: 0.55rem!important;
        font-weight: 400;
      }
    }
    span{
      font-size: 32px;
      margin-left: 5px;
    }
  }
  .panleTitle{
    margin-top: 30px;
    height: 60px;
    display: block;
    line-height: 65px;
    margin-left: 20px;
    font-size: 32px;
    text-align: left;
  }
  .mainBox{
    max-height: 17rem;
    overflow: auto;
    background-color: #fff;
  }
  .panleBox{
    width: 92%;
    font-size: 18px;
    margin:15% 0 2.5rem 0.34667rem;
  }
  .banner{
    display: flex;
    margin-top: -0.26667rem;
    text-align: center;
    position: fixed;
    bottom: 0.68rem;
    background: #fff;
    width: 100%;
    justify-content: center;
    padding: 10px 0;
    padding-bottom: env(safe-area-inset-bottom);
  }
  .checkedIcon{
    color: #0c00b4;
    font-size: 0.45rem;
    margin-right: 0.1rem;
    line-height: 0.8rem;
  }
  .section {
    padding-top: 20px;
    font-size: 28px;
    color: #999;
    margin-left: 10px;
    margin-bottom: 20px;
    .details{
      background-color: #fff;
      margin-bottom: 100px;
      box-shadow: 0px 20px 30px -30px #000;
    }
    .atu{
      height: auto !important;
    }
    .atu:nth-last-of-type(1){
      border: none;
    }
  }
  .brs{
    border-radius: 0.3rem;
    border:1px solid #ccc;
    margin-bottom: 20px;
  }
  .brs_bottom{
    border-radius: 0.3rem;
    margin-bottom: 20px;
  }
  .brs_box{
    background-image: url("../../../assets/images/tj/salaryBj.jpg");
    background-size: cover;
    box-shadow: 0px 20px 30px -30px #000;
  }
  .lineNum{
    line-height: 1rem;
    height: 1rem;
    margin-bottom: 0.3rem;
    font-size: 0.42rem;
    text-align: center;
    // background-color: #090097;
    border-top-left-radius: 0.13333rem;
    border-top-right-radius: 0.13333rem;
    .lineNum_flag{
      width: 0.18rem;
      display: block;
      height: 0.55rem;
      float: left;
      background-color: #0a0096;
      margin: 0.22rem;
      border-radius: 0.06rem;
    }
    span{
      color: #000;
      font-size: 0.42rem;
      text-align: left;
      display: block;
    }
  }
  .lineNum2{
    line-height: 1rem;
    height: 1rem;
    margin-bottom: 0.3rem;
    font-size: 0.40rem;
    text-align: center;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    span{
      color:#fff;margin-left:20px;
    }
  }
  .flex-mb8 {
    display: flex;
    margin-bottom: 10px;
    height: 60px;
    line-height: 60px;
    border-bottom: 1px dashed #ccc;
  }
  .flex-mb8-up {
    display: flex;
    margin-bottom: 30px;
    height: 60px;
    line-height: 60px;
  }
  .key{
    font-size: 0.38rem;
    color: #333;
    width: 50%;
    text-align: left;
  }
  .value{
    font-size: 0.38rem;
    color: #666;
    text-align: right;
    width: 50%;
  }
  .question_icon{
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 0.5rem;
    background-color: #a7a3a3;
    position: fixed;
    right: 0;
    bottom: 10px;
    color: #fff;
  }
  .password_content{
    /deep/ .van-field__label{
      width: 80px;
    }
  }
</style>
